import React from "react";
import MusicIcon from "../../../../public/shared/music-default.svg";
import { ReactComponent as MenuIcon } from "../../../../public/shared/menu-icon-default.svg";
import UserTag from "../../shared/UserTag";

export default ({ item }) => {
  return (
    <>
      {item.type === "Post" && (
        <div className="mb-3 trending-item">
          <label className="text-default mb-2">Post</label>
          <div className="d-flex align-items-center">
            <UserTag user={item.author} className="text-dark w-100" disabled />
            <MenuIcon className="more-trending-icon" />
          </div>
        </div>
      )}
      {item.type === "SoundTrack" && (
        <div className="mb-3 trending-item">
          <label className="text-default mb-2">Music</label>
          <div className="d-flex align-items-center">
            <div className="media w-100">
              <img
                className="mr-3 rounded"
                width={40}
                height={40}
                src={
                  (item.preview_image && item.preview_image.url) || MusicIcon
                }
                alt="profile_picture"
              />
              <label className="text-dark my-auto">{item.title}</label>
            </div>
            <MenuIcon className="more-trending-icon" />
          </div>
        </div>
      )}

      {/* {item.type === "hashtag" && (
        <div className="mb-3 trending-item">
          <label className="text-default mb-2">Music</label>
          <div className="d-flex align-items-center">
            <div className="media w-100">
              <img
                className="mr-3 rounded"
                width={40}
                height={40}
                src={(data.img && data.img.url) || HashtagIcon}
                alt="profile_picture"
              />
              <label className="text-dark my-auto">{data.phrase}</label>
            </div>
            <MenuIcon className="more-trending-icon" />
          </div>
        </div>
      )} */}
    </>
  );
};
